const buttonFadeDurationMs = 100;
const container = "_35sc120jm7o";
const scrollButton = "_35ssnbym1a";
const scroller = "_35ss1x88xkv";
const label = "_35sl1evw9pj";

export { buttonFadeDurationMs, container, label, scrollButton, scroller };
import "./molecule.dropzones.style.linaria.module.css";
//# sourceMappingURL=molecule.dropzones.style.js.map
